<template>
  <div class="content content-depotfinder">
    <div class="content__inner">
      <div class="wrapper">
        <BackButton @click="handleBack('/depotfinder')" />

        <NextArrowButton :nextStep="nextStep" />

        <Depositmodels />

        <div
          class="depotfinder__question text-centered wrapper wrapper--medium"
        >
          <UiHeadline
            tag="h1"
            size="large"
            theme="primary"
            align="center"
            class="depotfinder__headline"
          >
            {{ $t("depotfinder.services.headline") }}
          </UiHeadline>

          <p class="depotfinder__subline">
            {{ $t("depotfinder.services.subline") }}
          </p>
        </div>

        <div class="text-centered mt-3">
          <ServicesSelect />

          <NextButton :nextStep="nextStep" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UiHeadline from "./../../components/Ui/Headline.vue";
import Depositmodels from "./../../components/DepositModels.vue";
import ServicesSelect from "./../../components/ServicesSelect.vue";
import BackButton from "./../../components/BackButton.vue";
import NextButton from "./../../components/NextButton.vue";
import NextArrowButton from "./../../components/NextArrowButton.vue";
import { backButtonMixin } from "./../../mixins/handleBackButton";

export default {
  mixins: [backButtonMixin],
  components: {
    Depositmodels,
    ServicesSelect,
    BackButton,
    NextButton,
    NextArrowButton,
    UiHeadline,
  },
  computed: {
    recommendedDeposit() {
      return this.$store.getters.getRecommendedDeposit;
    },
    nextStep() {
      let nextStep = "";
      // user selected nothing
      if (this.$store.getters.getServicesState == "") {
        nextStep = "depotfinder.results";
        this.setRecommendedDeposit("DepotKomfort");
        // user selected any amount of options
      } else if (this.$store.getters.getServicesState != "") {
        nextStep = "depotfinder.results";
        this.setRecommendedDeposit("DepotExklusiv");
      }
      return nextStep;
    },
  },
  methods: {
    setRecommendedDeposit(value) {
      this.$store.dispatch("updateRecommendedDeposit", value);
    },
  },
  mounted() {
    this.setRecommendedDeposit("");
  },
};
</script>
